import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import { METRO_ELEMENT_DEFAULT } from '../../../constants/state'
import EditElement from '../../PageEditItem/present/EditElement'
import { addFlyerElement } from '../../../actions'

const mapDispatchToProps = (dispatch, ownProps) => ({
    addFlyerItem: (item, elementType) => {
        dispatch(addFlyerElement(elementType, item))
    }
})

const AddMetroContainer = ({addFlyerItem, itemType, closePagePath}) => (
    <EditElement 
        closePagePath={closePagePath}
        itemType={itemType}
        itemData={METRO_ELEMENT_DEFAULT}
        onUpdateItem={addFlyerItem}
    />
)

export default compose(
    connect(null, mapDispatchToProps),
    toJS()
)(AddMetroContainer)